import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "../Features/userSlice";
import guestReducer from "../Features/guestSlice";
import roomReducer from "../Features/roomSlice";

// Custom serializer to only store essential data
const customSerializer = {
  serialize: (data) => {
    try {
      // If it's user data, only store essential fields
      if (data && typeof data === 'object' && data.currentUser) {
        const essentialUserData = {
          ...data,
          currentUser: {
            // Only store essential user fields, exclude massive Cognito object
            username: data.currentUser.username,
            attributes: data.currentUser.attributes ? {
              sub: data.currentUser.attributes.sub,
              email: data.currentUser.attributes.email,
              email_verified: data.currentUser.attributes.email_verified
            } : undefined,
            // Exclude pool, signInUserSession, and other massive objects
          }
        };
        return JSON.stringify(essentialUserData);
      }
      return JSON.stringify(data);
    } catch (error) {
      console.warn('Serialization failed:', error);
      return JSON.stringify({});
    }
  },
  deserialize: (data) => {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.warn('Deserialization failed:', error);
      return {};
    }
  }
};

// Configure the persist settings
const persistConfig = {
  key: "root", // This is the key for the persisted data in storage
  storage, // Define the storage engine
  whitelist: ["user", "guest", "room"],
  serialize: customSerializer.serialize,
  deserialize: customSerializer.deserialize,
};

// Create the root reducer
const rootReducer = combineReducers({
  user: userReducer,
  guest: guestReducer,
  room: roomReducer,
  // add other reducers here
});

// Wrap the root reducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Create the persistor
export const persistor = persistStore(store);
